import HomePage from './pages/Home/HomePage';
import ServicesPage from './pages/Services/ServicesPage';
import AboutPage from './pages/About/AboutPage';
import ContactPage from './pages/Contact/ContactPage';
import PrivacyPage from './pages/Privacy/PrivacyPage';
import NotFoundPage from './pages/NotFound/NotFoundPage';

export const PAGES = {
  '/': HomePage,
  '/services': ServicesPage,
  '/about': AboutPage,
  '/contact': ContactPage,
  '/privacy-policy': PrivacyPage,
};

export { NotFoundPage };
